var _style, _g, _path, _g2, _g3, _g4, _g5, _polyline, _polyline2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 915 582",
    style: {
      enableBackground: "new 0 0 915 582"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#2A5BA6;stroke-width:6;stroke-miterlimit:10;}\r\n\t.st1{fill:#6CA442;stroke:#2A5BA6;stroke-width:6;stroke-miterlimit:10;}\r\n\t.st2{fill:#54A345;}\r\n\t.st3{fill:#F26B39;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#9BCCEE;stroke:#2A5BA6;stroke-width:6;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st6{fill:none;stroke:#686969;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:7;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_65_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "form"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M180.3,542H19.7c-3.4,0-6.2-2.8-6.2-6.2v-191c0-3.4,2.8-6.2,6.2-6.2h141 c1.7,0,3.3,0.7,4.5,1.9l19.7,20.8c1.1,1.2,1.7,2.7,1.7,4.3v170.3C186.6,539.3,183.7,542,180.3,542z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_60_",
    className: "st1",
    points: "160.5,341.5 160.5,367.5 184.3,367.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "form_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M193.2,556.1H32.6c-3.4,0-6.2-2.8-6.2-6.2v-191c0-3.4,2.8-6.2,6.2-6.2h141 c1.7,0,3.3,0.7,4.5,1.9l19.7,20.8c1.1,1.2,1.7,2.7,1.7,4.3v170.3C199.4,553.4,196.6,556.1,193.2,556.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    className: "st1",
    points: "173.4,355.6 173.4,381.6 197.2,381.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "form_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st0",
    d: "M207.3,573.6H46.7c-3.4,0-6.2-2.8-6.2-6.2v-191c0-3.4,2.8-6.2,6.2-6.2h141 c1.7,0,3.3,0.7,4.5,1.9l19.7,20.8c1.1,1.2,1.7,2.7,1.7,4.3v170.3C213.5,570.8,210.7,573.6,207.3,573.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4_",
    className: "st1",
    points: "187.5,373 187.5,399.1 211.3,399.1  "
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_32_",
    x: 61.1,
    y: 427.8,
    className: "st2",
    width: 126.4,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_34_",
    x: 61.1,
    y: 440.3,
    className: "st2",
    width: 126.4,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_35_",
    x: 61.1,
    y: 454.4,
    className: "st2",
    width: 126.4,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_36_",
    x: 61.9,
    y: 468.3,
    className: "st2",
    width: 126.4,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_37_",
    x: 61.9,
    y: 481.6,
    className: "st2",
    width: 126.4,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_39_",
    x: 63.5,
    y: 494.8,
    className: "st2",
    width: 89,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_38_",
    x: 63.5,
    y: 508.1,
    className: "st2",
    width: 89,
    height: 7.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_56_",
    className: "st3",
    d: "M563.2,95.4c2.3-4.5,3.2-10.1,3.2-15.6c0-24-22.1-43.5-48.7-43.5c-10.1,0-19.5,2.6-26.9,7.1 c-14-21.4-40.2-36.4-70.1-36.4c-44.8,0-81.1,32.5-81.1,72.4c0,1.3,0,2.6,0,3.9c-28.2,8.8-48.7,33.1-48.7,61.7 c0,36,32.5,65.2,73,65.2h187c36,0,65.2-25.6,65.2-57.8C614.8,124,592.7,100.9,563.2,95.4z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_40_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "st4",
    d: "M359.8,137h-13l-2.5,6h-6.6l12.5-28h6.4l12.5,28h-6.8L359.8,137z M357.7,132.1l-4.4-10.7 l-4.4,10.7H357.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    className: "st4",
    d: "M405.5,123.5c1.6,1.6,2.4,4,2.4,7.1V143h-6.2v-11.4c0-1.7-0.4-3-1.1-3.8 c-0.7-0.8-1.7-1.3-3-1.3c-1.5,0-2.6,0.5-3.5,1.4c-0.9,0.9-1.3,2.4-1.3,4.2V143h-6.2v-11.4c0-3.4-1.4-5.1-4.1-5.1 c-1.4,0-2.6,0.5-3.4,1.4c-0.9,0.9-1.3,2.4-1.3,4.2V143h-6.2v-21.5h6v2.5c0.8-0.9,1.8-1.6,2.9-2.1c1.2-0.5,2.4-0.7,3.8-0.7 c1.5,0,2.9,0.3,4.1,0.9c1.2,0.6,2.2,1.5,3,2.6c0.9-1.1,2-2,3.3-2.6c1.3-0.6,2.8-0.9,4.4-0.9C401.8,121.2,403.9,122,405.5,123.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st4",
    d: "M429.8,123.5c1.8,1.6,2.7,4,2.7,7.2V143h-5.8v-2.7c-1.2,2-3.4,3-6.6,3c-1.7,0-3.1-0.3-4.3-0.8 c-1.2-0.6-2.1-1.3-2.8-2.3c-0.6-1-1-2.1-1-3.4c0-2,0.8-3.6,2.3-4.7c1.5-1.1,3.8-1.7,7-1.7h5c0-1.4-0.4-2.4-1.2-3.1 c-0.8-0.7-2.1-1.1-3.7-1.1c-1.1,0-2.3,0.2-3.4,0.5c-1.1,0.4-2,0.8-2.8,1.5l-2.2-4.4c1.2-0.8,2.6-1.5,4.2-1.9 c1.6-0.5,3.3-0.7,5.1-0.7C425.5,121.2,428.1,122,429.8,123.5z M424.5,138.4c0.8-0.5,1.4-1.2,1.8-2.2V134H422 c-2.6,0-3.8,0.8-3.8,2.5c0,0.8,0.3,1.4,0.9,1.9c0.6,0.5,1.5,0.7,2.6,0.7C422.7,139.1,423.7,138.9,424.5,138.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st4",
    d: "M455.9,138.2v4.8h-19.2v-3.8l11-13H437v-4.8h18.6v3.8l-11,13H455.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st4",
    d: "M463.7,141.9c-1.8-0.9-3.2-2.3-4.2-3.9s-1.5-3.6-1.5-5.7s0.5-4,1.5-5.7s2.4-3,4.2-3.9 c1.8-0.9,3.8-1.4,6.1-1.4s4.3,0.5,6.1,1.4c1.8,0.9,3.2,2.3,4.2,3.9c1,1.7,1.5,3.6,1.5,5.7s-0.5,4-1.5,5.7c-1,1.7-2.4,3-4.2,3.9 c-1.8,0.9-3.8,1.4-6.1,1.4S465.5,142.8,463.7,141.9z M473.8,136.6c1-1.1,1.5-2.5,1.5-4.3s-0.5-3.3-1.5-4.3s-2.3-1.6-3.9-1.6 c-1.6,0-2.9,0.5-4,1.6s-1.6,2.5-1.6,4.3s0.5,3.3,1.6,4.3s2.4,1.6,4,1.6C471.4,138.2,472.8,137.7,473.8,136.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    className: "st4",
    d: "M505.3,123.6c1.6,1.6,2.5,4,2.5,7.1V143h-6.2v-11.4c0-1.7-0.4-3-1.1-3.8 c-0.7-0.8-1.8-1.3-3.2-1.3c-1.6,0-2.8,0.5-3.8,1.5c-0.9,1-1.4,2.4-1.4,4.3V143h-6.2v-21.5h6v2.5c0.8-0.9,1.9-1.6,3.1-2.1 c1.2-0.5,2.6-0.7,4-0.7C501.5,121.2,503.7,122,505.3,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_57_",
    className: "st4",
    d: "M528,142.6c-2.1-0.6-3.7-1.4-5-2.3l2.2-4.9c1.2,0.9,2.6,1.6,4.3,2.1c1.7,0.5,3.3,0.8,5,0.8 c1.8,0,3.2-0.3,4.1-0.8c0.9-0.5,1.3-1.3,1.3-2.2c0-0.7-0.3-1.2-0.8-1.7c-0.5-0.4-1.2-0.8-2-1.1c-0.8-0.3-1.9-0.6-3.3-0.9 c-2.1-0.5-3.9-1-5.2-1.5c-1.4-0.5-2.5-1.3-3.5-2.4c-1-1.1-1.5-2.6-1.5-4.5c0-1.6,0.4-3.1,1.3-4.4c0.9-1.3,2.2-2.4,4-3.1 c1.8-0.8,3.9-1.2,6.5-1.2c1.8,0,3.5,0.2,5.2,0.6c1.7,0.4,3.2,1,4.5,1.8l-2,4.9c-2.6-1.5-5.2-2.2-7.8-2.2c-1.8,0-3.2,0.3-4,0.9 c-0.9,0.6-1.3,1.4-1.3,2.3s0.5,1.7,1.5,2.1c1,0.5,2.5,0.9,4.6,1.4c2.1,0.5,3.9,1,5.2,1.5c1.4,0.5,2.5,1.3,3.5,2.4 c1,1.1,1.5,2.6,1.5,4.4c0,1.6-0.4,3.1-1.3,4.4c-0.9,1.3-2.2,2.4-4,3.1c-1.8,0.8-4,1.2-6.5,1.2C532.2,143.5,530,143.2,528,142.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    className: "st4",
    d: "M567.5,129.1c1.3,1.4,2,3.2,2,5.3c0,1.6-0.4,3.1-1.3,4.5c-0.9,1.4-2.2,2.5-3.9,3.3 c-1.7,0.8-3.9,1.2-6.4,1.2c-2,0-3.9-0.3-5.8-0.8c-1.9-0.5-3.5-1.3-4.9-2.2l2.5-5c1.1,0.8,2.3,1.4,3.7,1.9c1.4,0.4,2.8,0.7,4.3,0.7 c1.6,0,2.9-0.3,3.8-0.9c0.9-0.6,1.4-1.5,1.4-2.7c0-2.3-1.7-3.4-5.2-3.4h-3v-4.3l5.8-6.5h-11.9V115h19.6v4.2l-6.3,7.2 C564.3,126.8,566.2,127.7,567.5,129.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_64_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_33_",
    x: 618,
    y: 350,
    className: "st5",
    width: 286,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_62_",
    x: 638.2,
    y: 371.7,
    className: "st4",
    width: 157.8,
    height: 23.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_63_",
    className: "st2",
    cx: 868,
    cy: 383.4,
    r: 11.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_66_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_69_",
    x: 618,
    y: 428,
    className: "st5",
    width: 286,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_68_",
    x: 638.2,
    y: 449.7,
    className: "st4",
    width: 157.8,
    height: 23.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_67_",
    className: "st2",
    cx: 868,
    cy: 461.4,
    r: 11.6
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_70_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_73_",
    x: 618,
    y: 505,
    className: "st5",
    width: 286,
    height: 65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_72_",
    x: 638.2,
    y: 526.7,
    className: "st4",
    width: 157.8,
    height: 23.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_71_",
    className: "st2",
    cx: 868,
    cy: 538.4,
    r: 11.6
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_6_",
    className: "st6",
    points: "110.1,331.6 110.1,150.6 290,150.6 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_7_",
    className: "st6",
    points: "616.2,157.6 794.1,157.6 794.1,336.6 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.165da95ec6cb0632836d92424e5abcee.svg";
export { ForwardRef as ReactComponent };